import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { offerChecklist, offerSection } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function Offer() {
  return <section id="offer" aria-labelledby="offer-heading" className="w-full scroll-mt-16 border-t border-charcoal/10 bg-white px-5 py-14 md:px-8 md:py-24" data-id="element-127" data-mp="1hoxurjno15sn">
      <div className="mx-auto w-full max-w-content" data-id="element-128" data-mp="p0tmqrhmggms">
        <Reveal data-id="element-129" data-mp="p24ratiw5sey">
          <SectionHeading id="offer-heading" title={offerSection.title} data-id="element-130" data-mp="13wrfs0w914us" />
        </Reveal>

        <Reveal delay={0.06} data-id="element-131" data-mp="yxxzy1thp1rg">
          <div className="mx-auto mt-12 max-w-2xl overflow-hidden rounded-xl border border-charcoal/10 bg-ivory shadow-[0_24px_60px_-36px_rgba(16,44,37,0.45)] md:mt-14" data-id="element-132" data-mp="yxogyy6v3uv9">
            <div aria-hidden="true" className="h-1 w-full bg-brass" data-id="element-133" data-mp="2add7fzjbrc0t" />
            <div className="px-6 py-10 text-center sm:px-12 md:py-12" data-id="element-134" data-mp="2af7hujwyzlqn">
              <h3 className="font-serif text-[1.75rem] font-semibold leading-tight text-charcoal md:text-[2rem]" data-id="element-135" data-mp="pjfkqbzwipjp">
                {siteConfig.productName}
              </h3>
              <p className="mt-6 font-serif text-[4.5rem] font-medium leading-none text-forest md:text-[5.5rem]" data-id="element-136" data-mp="zhv8q63mtioz">
                {siteConfig.price}
              </p>
              <p className="mt-4 text-base font-semibold text-charcoal md:text-lg" data-id="element-137" data-mp="13hnn4zfpij29">
                {offerSection.includesLine}
              </p>

              <ul className="mx-auto mt-8 grid max-w-lg gap-3 border-t border-charcoal/10 pt-8 text-left sm:grid-cols-2" data-id="element-138" data-mp="btvkbctsm4dk">
                {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-charcoal md:text-base" data-id="element-139" data-mp="kkvz6cp7zfrv">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-140" data-mp="3k7kpwprt5gku">
                      <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="3o8o3f5mdv0iw" />
                    </span>
                    {item}
                  </li>)}
              </ul>

              <div className="mt-10" data-id="element-142" data-mp="qge0uqq98tcy">
                <CtaButton tone="onLight" fullWidth href={siteConfig.offerCheckoutUrl} data-id="element-143" data-mp="155agb8un58nl" />
              </div>

              <p className="mt-5 inline-flex items-center gap-2 text-[15px] font-semibold text-forest" data-id="element-144" data-mp="105xla0tm8v9x">
                <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="cg381i5dx4p5" />
                {siteConfig.guaranteeLabel}
              </p>
              <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-charcoal/70" data-id="element-146" data-mp="7jcvh4ssgr8h">
                {offerSection.microcopy}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}